(function() { window.GUID_f0a663cc_a878_4283_afc7_f03c670d5246 = { getGuid: function() { return "f0a663cc-a878-4283-afc7-f03c670d5246"; } }; })();
var CS;
(function (CS) {
    class StaticTester {
        static Create() {
            if (!CS.StaticTester.Instance) {
                CS.StaticTester.Instance = new CS.StaticTester();
                CS.StaticTester.Instance.Id = 0;
            }
            $(() => {
                if (!CS.StaticTester.Instance) {
                }
            });
        }
        constructor() {
        }
    }
    CS.StaticTester = StaticTester;
})(CS || (CS = {}));

//# sourceMappingURL=cs-static.js.map
